/** @jsx jsx */
import React, { useState } from 'react';
import { css, jsx } from '@emotion/core';

import FormLabel from 'components/atoms/Form/FormLabel';
import PasswordInput from 'components/atoms/Form/PasswordInput';
import VerticalLabelFormLayout from 'components/atoms/Form/VerticalLabelFormLayout';
import Icon from 'components/atoms/Icon';
import { grayScale } from 'components/styles';

const styles = {
  inputWrapper: css({
    position: 'relative',
    display: 'flex',
  }),
  toggle: css({
    position: 'absolute',
    top: '4px',
    right: '8px',
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    outline: 'none',
    cursor: 'pointer',
  }),
};

const PasswordForm: React.FC<{
  name: string;
  label: string;
  value: string;
  width?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  errorMsg?: string;
}> = ({
  name, label, value, onChange, width, errorMsg,onKeyPress
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <VerticalLabelFormLayout
      label={(
        <FormLabel
          label={label}
        />
        )}
      input={(
        <div css={styles.inputWrapper}>
          <PasswordInput
            name={name}
            label={label}
            value={value}
            visible={visible}
            onChange={onChange}
            onKeyPress={onKeyPress}
          />
          <button
            type="button"
            css={styles.toggle}
            onClick={() => setVisible(!visible)}
          >
            <Icon
              type={visible ? 'eyeOff' : 'eye'}
              color={grayScale.gray50}
              hoverColor={grayScale.gray100}
            />
          </button>
        </div>
        )}
      errorMsg={errorMsg}
    />
  );
};

export default PasswordForm;
